import {LocalStorage} from "@/models/facade/storage/LocalStorage";
import {SessionStorage} from "@/models/facade/storage/SessionStorage";

export class Storage {
    public static readonly local = LocalStorage.getInstance();
    public static readonly session = SessionStorage.getInstance();
}
